import { Toaster } from 'sonner';

import { useTheme } from '@/shadcn/theme/theme-provider';

export { toast as notify } from 'sonner';

export { CustomToast } from './customToast/customToast';

export const CustomToaster = () => {
  const { theme } = useTheme();
  return (
    <Toaster closeButton position="bottom-left" richColors theme={theme} />
  );
};
